export const accessDenied = "access-denied"
export const serviceUnavailable = "service-unavailable"
export const unauthorized = "unauthorized"
export const noTransactionFound = "no-transaction-found"
export const notFound = "*"
